import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { ApiGetDataStatus, AdminUsersStateType } from '@redux/types'
import { User, UserType } from '@schemas'

// initial state
const initialState: AdminUsersStateType = {
	// trigger
	triggerInitAdminUser: false,

	// users
	userList: [],
	userListStatus: 'init',
	editUserProfileImage: { id: '' },
	editPasswordUser: new User(),
	resetPasswordErrorMessage: '',
	updateUser: {
		iudFlag: '',
		id: '',
		name: '',
		email: '',
		language: '',
		useYn: 1,
	},
	updateResetPassword: {
		id: '',
		name: '',
		password: '',
	},
	upldateProfileImage: {
		userId: '',
		profileImage: null,
	},
}

const slice = createSlice({
	name: 'adminUsers',
	initialState,
	reducers: {
		// trigger
		TRIGGER_INIT_ADMIN_USERS: (
			state: AdminUsersStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerInitAdminUser = action.payload
		},

		// users
		USER_LIST: (state: AdminUsersStateType, action: PayloadAction<UserType[]>) => {
			state.userList = action.payload
		},
		USER_LIST_STATUS: (
			state: AdminUsersStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.userListStatus = action.payload
		},
		EDIT_USER_PROFILE_IMAGE: (
			state: AdminUsersStateType,
			action: PayloadAction<AdminUsersStateType['editUserProfileImage']>,
		) => {
			state.editUserProfileImage = action.payload
		},
		EDIT_UPASSWORD_USER: (
			state: AdminUsersStateType,
			action: PayloadAction<AdminUsersStateType['editPasswordUser']>,
		) => {
			state.editPasswordUser = action.payload
		},
		RESET_PASSWORD_ERROR_MESSAGE: (
			state: AdminUsersStateType,
			action: PayloadAction<string>,
		) => {
			state.resetPasswordErrorMessage = action.payload
		},
		UPDATE_USER: (
			state: AdminUsersStateType,
			action: PayloadAction<AdminUsersStateType['updateUser']>,
		) => {
			state.updateUser = action.payload
		},
		UPDATE_RESET_PASSWORD: (
			state: AdminUsersStateType,
			action: PayloadAction<AdminUsersStateType['updateResetPassword']>,
		) => {
			state.updateResetPassword = action.payload
		},
		UPLDATE_PROFILE_IMAGE: (
			state: AdminUsersStateType,
			action: PayloadAction<AdminUsersStateType['upldateProfileImage']>,
		) => {
			state.upldateProfileImage = action.payload
		},
	},
})

export const adminUsersActions = slice.actions
export default slice.reducer
